import { Box, Divider, Typography } from "@mui/material";
import { CurrentSubscriptionDetails } from "../../store/auth-slice/auth-slice";
import { useTranslation } from "react-i18next";

interface SubscriptionDetailsProps {
    subscription: CurrentSubscriptionDetails | null;
}

function SubscriptionDetails({ subscription }: SubscriptionDetailsProps) {
    const { t } = useTranslation();
    const hasActiveStatus = subscription?.status === "BE_MEDML_SUBSCRIPTION_STATUS_ACTIVE" || subscription?.status === "BE_MEDML_SUBSCRIPTION_TRIAL_NAME";

    if (!subscription) {
        return null;
    }

    return (
        <Box sx={{ px: 2, pb: 1.5, pt: 0.5, width: '100%' }}>
            <Typography
                variant="subtitle1"
                sx={{
                    color: 'text.primary',
                    fontWeight: 600,
                    typography: { xs: 'body2', sm: 'subtitle1' },
                }}
            >
                {t('CURRENT_SUBSCRIPTION_TITLE', { name: t(subscription.name) })}
            </Typography>
            <Typography
                variant="subtitle1"
                sx={{
                    color: hasActiveStatus ? 'text.primary': 'error.main',
                    fontWeight: 600,
                    typography: { xs: 'body2', sm: 'subtitle1' },
                }}
            >
                {t('CURRENT_SUBSCRIPTION_STATUS', { status: t(subscription.status) })}
            </Typography>
            <Divider sx={{ my: 1 }} />
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
                {subscription.items?.map((item, index) => (
                    <Box
                        key={`${item.name}-${index}`}
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start',
                            gap: 1,
                            flexWrap: 'wrap',
                        }}
                    >
                        <Typography
                            variant="body2"
                            sx={{ color: 'text.secondary', typography: { xs: 'body2', sm: 'body2' } }}
                        >
                            {t(item.name)}
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={{
                                color: 'text.primary',
                                fontWeight: 600,
                                textAlign: 'right',
                                wordBreak: 'break-word',
                            }}
                        >
                            {item.value ?? '-'}
                        </Typography>
                    </Box>
                ))}
            </Box>
        </Box>
    );
}

export default SubscriptionDetails;
